<dx-popup
    #popupComponent
    class="popup"
    [width]="360"
    [height]="'auto'"
    [maxHeight]="'80vh'"
    [showTitle]="true"
    [title]="'Cancel Requisition'"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="false"
    [(visible)]="popupVisible">

    <dxi-toolbar-item location="after">
        <dx-button text="Save" [disabled]="comment === ''" (click)="cancel()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after" >
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view [showScrollbar]="'onScroll'">
        <form style="padding-bottom: 8px">

            <div fxLayout="column" fxLayoutAlign="start center ">
                <div class="dx-fieldset" style="width: 100%">
                    <div class="dx-field" style="width: 100%">
                        <div class="dx-field-label">Comment <span class="ocl-required-indicator">*</span></div>
                        <div class="dx-field-value" style="width: 100%">
                            <dx-text-area
                                (onContentReady)="ready($event)"
                                [height]="90"
                                [(value)]="comment">
                                <dx-validator>
                                    <dxi-validation-rule type="required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-text-area>
                        </div>
                    </div>
                </div>
            </div>

        </form>
        </dx-scroll-view>
    </div>

</dx-popup>

